import React, { FC, useState, useEffect } from 'react';
import { SCUIButton, SCUIDateRanger, SCUIAutoCompleteInput } from '../../../atomic/atoms';
import CloseIcon from '@mui/icons-material/Close';
import { starScoreLookupList } from '../../../pages/ProductComments/CommentList/CommentList.config';
import './SCUICommentListForm.scss';
import { enumStarScoreFlowStatus, enumCommentStatusFlowStatus } from '../../../types/enums/status';

import { SCUIControllerSelectbox, SCUIControllerTextField } from '../../../atomic/molecules';
import { FormControl, InputLabel, Grid, Select, MenuItem } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface IProps {
    formFilterInfo: any;
    tagNames: any;
    operators: any;
    param: any;
    myFilterInfo: any;
    onClose: any;
    agentStatuses: any;
    grievanceStatusList: any;
}
export const SCUICommentListForm: FC<IProps> = ({
    formFilterInfo,
    tagNames,
    operators,
    myFilterInfo,
    onClose,
    agentStatuses,
    grievanceStatusList,
}) => {
    const { t } = useTranslation();
    const commentStatusLookupList = [
        {
            id: enumCommentStatusFlowStatus.minusOne,
            value: t('general.all'),
        },
        {
            id: enumCommentStatusFlowStatus.one,
            value: t('general.waitingForApproval'),
        },
        {
            id: enumCommentStatusFlowStatus.two,
            value: t('general.approved'),
        },
        {
            id: enumCommentStatusFlowStatus.three,
            value: t('general.declined'),
        },
    ];

    const { handleSubmit: _filterFormSubmit, control: filterFormControl } = useForm();
    const [tagName, setTagName] = React.useState<string[]>(myFilterInfo.tagName);
    const [operator, setOperator] = React.useState<string[]>(myFilterInfo.operator);
    const [displayedTags, setDisplayedTags] = React.useState([]);
    const [filterInfo, setFilterInfo] = useState(myFilterInfo);
    const [endDate, setEndDate] = useState('');
    const [isAgent, setIsAgent] = useState(-1);
    const [createdDate, setCreatedDate] = useState('');
    useEffect(() => {
        setDisplayedTags(tagNames && tagNames.filter((item: any) => filterInfo.tagName?.includes(item.id)));
    }, [tagNames]);
    const _handlChangeDate = (event: any) => {
        setCreatedDate(event[0]);
        setEndDate(event[1]);
    };
    const _handlChangeTag = (event: any, newValue: any) => {
        setDisplayedTags(newValue);
        setTagName(
            newValue.map(function (item: any) {
                return item.id;
            })
        );
        filterInfo.tagName = [...tagName];
    };
    const handleChangeOperator = (event: any) => {
        setOperator(event.target.value);
        filterInfo.operator = [...operator];
    };
    const handleIsAgentChange = (event: any) => {
        setIsAgent(event.target.value);
        filterInfo.isAgent = isAgent;
    };

    const _onSubmitFilterForm = (filterForm: any) => {
        filterForm.tagName = [...tagName];
        filterForm.operator = [operator];
        filterForm.createDate = createdDate;
        filterForm.endDate = endDate;
        filterForm.isAgent = isAgent;
        setFilterInfo(filterForm);
        formFilterInfo(filterForm);
    };

    return (
        <form onSubmit={_filterFormSubmit(_onSubmitFilterForm)}>
            <div className="commentFilterContainer">
                <Grid container spacing={2}>
                    <Grid
                        size={{
                            md: 1,
                            xs: 1,
                            lg: 1,
                        }}
                    >
                        <CloseIcon className="svg_icons" onClick={onClose} />
                    </Grid>
                    <Grid
                        sx={{ marginBottom: 2 }}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <SCUIControllerTextField
                            fullWidth
                            //placeholder={"Option Id"}
                            label={'Option Id'}
                            size={'l'}
                            formControl={filterFormControl}
                            value={filterInfo.optionId}
                            variant={'outlined'}
                            shrink={true}
                            stateName={'optionId'}
                        />
                    </Grid>
                    <Grid
                        sx={{ marginBottom: 2 }}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <SCUIControllerTextField
                            fullWidth
                            label={t('comments.specialCode')}
                            formControl={filterFormControl}
                            // placeholder={"specialCode"}
                            size={'l'}
                            value={filterInfo.specialCode}
                            variant={'outlined'}
                            shrink={true}
                            stateName={'specialCode'}
                        />
                    </Grid>

                    <Grid
                        sx={{ marginBottom: 2 }}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <SCUIControllerTextField
                            fullWidth
                            label={t('comments.colorCode')}
                            formControl={filterFormControl}
                            // placeholder={"specialCode"}
                            size={'l'}
                            value={filterInfo.colorCode}
                            variant={'outlined'}
                            shrink={true}
                            stateName={'colorCode'}
                        />
                    </Grid>
                    <Grid
                        sx={{ marginBottom: 2 }}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <SCUIControllerSelectbox
                            fullWidth
                            name="starScore"
                            label={t('comments.selectPoint')}
                            selectList={filterInfo.starScore}
                            list={[
                                ...[
                                    {
                                        id: enumStarScoreFlowStatus.minusOne,
                                        value: t('general.all'),
                                    },
                                ],
                                ...starScoreLookupList,
                            ]}
                            formControl={filterFormControl}
                            value={t('comments.selectPoint')}
                            stateName={'starScore'}
                            size={'m'}
                        />
                    </Grid>
                    <Grid
                        sx={{ marginBottom: 2 }}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <SCUIDateRanger
                            fromDate={filterInfo.createDate}
                            toDate={filterInfo.endDate}
                            setDateRange={_handlChangeDate}
                            dateFormat="YYYY-MM-DD"
                        />
                    </Grid>

                    <Grid
                        sx={{ marginBottom: 2 }}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <SCUIControllerSelectbox
                            fullWidth
                            name="commentStatus"
                            label={t('comments.selectStatus')}
                            selectList={filterInfo.commentStatus}
                            list={commentStatusLookupList}
                            formControl={filterFormControl}
                            value={t('comments.selectStatus')}
                            stateName={'commentStatus'}
                            size={'m'}
                        />
                    </Grid>

                    <Grid
                        sx={{ marginBottom: 2 }}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <SCUIControllerSelectbox
                            fullWidth
                            name="grievanceStatus"
                            label={t('comments.grievance')}
                            selectList={filterInfo.grievanceStatus}
                            list={grievanceStatusList}
                            formControl={filterFormControl}
                            value={'comments.grievance'}
                            stateName={'grievanceStatus'}
                            size={'m'}
                        />
                    </Grid>
                    <Grid
                        sx={{ marginBottom: 2 }}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <FormControl fullWidth>
                            <InputLabel id="isAgentSelect"> {t('general.isAgent')}</InputLabel>
                            <Select
                                labelId="isAgentSelectlabel"
                                id="isAgentSelect"
                                label={t('general.isAgent')}
                                value={isAgent}
                                onChange={handleIsAgentChange}
                            >
                                {agentStatuses.map((agent: any) => (
                                    <MenuItem key={agent.id} value={agent.id}>
                                        {agent.value}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    {operators && (
                        <Grid
                            sx={{ marginBottom: 2 }}
                            size={{
                                xs: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            }}
                        >
                            <FormControl fullWidth>
                                <InputLabel id="opertorselectlabel"> {t('general.operator')}</InputLabel>
                                <Select
                                    labelId="opertorselectlabel"
                                    id="opertorselect"
                                    label={t('general.operator')}
                                    value={operator}
                                    onChange={handleChangeOperator}
                                >
                                    {operators.map((operator: any) => (
                                        <MenuItem
                                            key={operator.username}
                                            value={operator.applicationUserId + '_' + operator.userRef}
                                        >
                                            {operator.username}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    )}
                    <Grid
                        sx={{ marginBottom: 2 }}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <FormControl fullWidth>
                            {displayedTags && (
                                <SCUIAutoCompleteInput
                                    list={tagNames}
                                    onChange={_handlChangeTag}
                                    limitTags={1}
                                    txtPlaceHolder={t('general.tag')}
                                    searchValue="keyWord"
                                />
                            )}
                        </FormControl>
                    </Grid>
                    <Grid
                        className="button"
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <SCUIButton text={t('general.filter')} type="primary" sizeType="fixed" size={'l'} />
                    </Grid>
                </Grid>
            </div>
        </form>
    );
};
